/**
 * Looking for gridSize? Use space tokens instead. If you need a token above 80px, or if you're setting width/height, just hardcode your value e.g. 240px.
 * Looking for borderRadius? Use a hardcoded 3px until tokens are available.
 */

// TODO(brizvash): move it to separate package or check is atlaskit will become compatible with compiled
export const layersLayer = 400; // layers.layer()
export const layersDialog = 300; // layers.dialog()
export const layersNavigation = 200; // layers.navigation()
